<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <a class="libere-header-menu" data-bs-toggle="offcanvas" href="#offcanvasRight"
                            aria-controls="offcanvasRight" style="outline: none">
                            <div class="" style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/menu.svg#menu"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    メニュー
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 17px;">
                            <br>
                            <div style="font-weight: 600;font-size: 20px;line-height: 30px;">
                                1年も経たずに良い従者に出会え、とても幸せです！
                            </div>
                            <div style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:10px 0;">
                                2023年3月28日
                            </div>
                            <br>
                            <img src="/images/Group13341.png" class="img-fluid">
                            <div class="text-center"
                                style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:15px 0;">
                                りょうこさん・女性40代 S(ドミ) 東海<br />
                                ゆうじさん・男性20代 M 東海
                            </div>
                            <br>
                            <p style="color:#6B4EFF;font-size:12px;">りょうこさん・女性40代 S(ドミ) 東海</p>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを始めたキッカケ</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                Lunaを使おうと思ったのは、S女同士やドミナントの人同士の話の中で、新しいSMのサービスができるという話を聞いて興味を持ったことがキッカケです。<br />
                                2022年7月にβ版がリリースされたと思いますが、そのときにβ版のテストユーザーに応募したところ、運良く当選したので、それ以来ずっと使っています。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaは始めた頃どんな印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                性癖でマッチする別のサービスも使ったことがありましたが、相手がSMに興味があることは分かっても、その人がSなのかMなのかが分からないサービスでした。SMが本当に好きな人には使いづらいと感じました。<br />
                                その点、Lunaはドミナント・サブミッシブやサド・マゾヒズムなどを丁寧に分けており、分かりやすくて良いと思いました。他のサービスでここまで細かく分類しているのを見たことがありません。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>お相手とやり取りをしていてお相手はどのような印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                最初にマッチをした時は、相手のTwitterが鍵垢だったので、「どうして鍵垢なんだろう？どんなこと呟いているのかな？」と思いました。<br />
                                基本的に話は誰とでもするのですが、会うとなると中身がわからないと嫌でした。<br />
                                そこで話をして、鍵を開けてもらったり、話していて、ツイッター自体を改善してもらうようお願いしました。<br />
                                今のままでは何を考えているのかわからないので、普段思っていることをつぶやいたり、名前を呼びやすくするよう提案したら、快く受け入れてくれました。<br />
                                好印象だったのは、素直に話を聞き、改善していってくれたことでした。<br />
                                <br />
                                <img src="/images/report4.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>会ったときのお相手の印象</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                8月頃にマッチをしたのですが、2週間もしないうちに会っていたと思います。 β版が終了し、本格的なサービスになったタイミングだったと思います。<br />
                                マッチングから2週間ほどで会うことになったのは、いつものように日常会話を話しているうちに、今週は何をするか話していたら、予定が空いており、タイミングが合ったのでその流れで会うことになりました。<br />
                                予定が合うことはとても大事で、お休みの日が同じだったり、夜勤がないなど、生活リズムが一緒だったりすることがとても重要だと思っています。<br />
                                初めて会った時は、とても私に嫌われたくないという気持ちが伝わってくるような子でした。 私の嗜好は、人を変えていくことです。
                                例えば加虐すること自体が好きではなく、加虐という行為を通じて、人を変えていくことが好きなんです。<br />
                                そのため、私に嫌われたくないという感情を感じてる子を変えていくのは、楽しみでした。<br />
                                <br />
                                <img src="/images/report5.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>現在はどのようなご関係なんですか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                現在、私たちは半年ほど主従関係にあります。最初は彼が奴隷ちゃんという役割でしたが、現在は恋人兼奴隷ちゃんという関係です。 私のパジャマや荷物を彼の家に置くこともあります。<br />
                                関係性は徐々に変化しており、日常生活でも一緒に過ごす時間が増えてきました。<br />
                                この関係性は私たちにとって理想的ではなるのですが、私が多頭でもあるので、多少の難点もあります。<br />
                                ちなみに、もう1人日常的に会う主従関係の相手がいますが、その子は犬として扱っています。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを使われる方へ一言</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                Lunaで、一年も経たないうちに二人もの従者に出会えてあえてとても幸せです！<br />
                                Lunaは上手に使うと出会えるとてもいいサービスだと思います。<br />
                                これからLunaを使う人へアドバイスをするとすれば、女性はマッチをしやすいのですが、ただ闇雲にマッチをしていくのではなく、相手に興味を持って知りたいという気持ちで接していくとうまくいくのではないかと思います。<br />
                                特に、Mの男性は最初はイマイチだなと思っても、自己プロデュースがとても下手な人が多いので、女性の方から会話をしてあげて、彼らの魅力を引き出してあげるのがとても大事だと思います。<br />
                                少し手間でも、こちらから積極的に喋ってあげることで魅力を引き出してあげることが出来ると思います。<br />
                            </div>
                            <br>
                            <br>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;" onclick="window.location.href = '/report/page3'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0" style="">
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13342.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">次のレポート</div>
                                        <div style="font-size:12px;">Lunaに出会って人生が大きく変わりました！</div>
                                    </div>
                                    <div class="col-2 px-0 text-center">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/>.svg#page_right"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div style="border-radius: 6px;border: 1px solid #D9D9D9;padding:10px 0;" onclick="window.location.href = '/report/page4'">
                                <div class="row d-flex align-items-center">
                                    <div class="col-2 px-0 text-center" style="">
                                        <svg style="height:14px;width:9px;fill:#E6E6E6;">
                                            <use xlink:href="/images/<.svg#page_left"></use>
                                        </svg>
                                    </div>
                                    <div class="col-2 px-0">
                                        <img src="/images/Group13345.png" class="img-fluid">
                                    </div>
                                    <div class="col">
                                        <div style="font-size:10px;color#999">前のレポート</div>
                                        <div style="font-size:12px;">九州離島 × 横浜の1,900kmの超遠距離を乗り越え Lunaで結婚！</div>
                                    </div>
                                    <div class="col-2 px-0">
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import HeaderMenu from './../HeaderMenu.vue'
import Footer from './../FooterLogin.vue'

export default {
    data() {
        return {
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        Footer: Footer,
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #6B4EFF;
    text-decoration:none;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.item_box {
    padding: 30px 25px;
    background: #FFFFFF;
    border-radius: 10px;
}
</style>
